import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import ExternalLink from 'components/generic/ExternalLink.component';
import InlineSpinner from 'components/generic/InlineSpinner.component';
import CurrencySign from 'components/price/CurrencySign.component';
import S from 'constants/string.const';
import useTip from 'hooks/useTip.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { useTheme } from 'providers/Theme.provider';
import { selectBillingInvoices } from 'selectors/settings.selectors';
import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';
import C from 'utils/values/constant.util';

import { GetCustomerInvoices } from 'settings/billing/actions';

import CN from './LastMonthInvoice.module.scss';

const INVOICE_TYPE = C({
  subscription: 'Subscription',
});

const LastMonthInvoice = ({ invoices, fetchInvoices }) => {
  const salonId = useCurrentSalonId();
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  const { val: loading, yay: showLoading, nay: hideLoading } = useTip(true);
  const [lastSubscriptionInvoice, setLastSubscriptionInvoice] = useState(null);

  useEffect(() => {
    if (!salonId) return;

    showLoading();
    fetchInvoices(salonId, {}).finally(() => hideLoading());
  }, [salonId, fetchInvoices, showLoading, hideLoading]);

  useEffect(() => {
    if (invoices?.results?.length) {
      const subscriptionInvoice = invoices.results.find((inv) => inv.invoice_type === INVOICE_TYPE.subscription);
      setLastSubscriptionInvoice(subscriptionInvoice || null);
    }
  }, [invoices]);

  // NOTE: invoice_amount divide by 100 - the amount in pence not pounds
  // AND to divide by 1.2 to get the ex VAT amount -> (invoice_amount / 100) / 1.2 or

  const amountExVAT = lastSubscriptionInvoice?.invoice_amount / 120;
  if (!loading && !lastSubscriptionInvoice) {
    return <div className={CN.gap} />;
  }

  return (
    <div
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      {loading ? (
        <div className={CN.loading}>
          <InlineSpinner />
        </div>
      ) : (
        <div className={CN.container}>
          <div className={CN.amount}>
            {S.repeatButton} {t('staffAndBusiness.summary.subscriptionCost')} <CurrencySign value={amountExVAT} />
          </div>
          <ExternalLink link={lastSubscriptionInvoice?.invoice_pdf} download variant="link">
            <div className={CN.pdfLink}>{t('staffAndBusiness.summary.downloadInvoiceButton')}</div>
          </ExternalLink>
        </div>
      )}
    </div>
  );
};

const LastMonthInvoiceHoc = connect(
  (state) => ({
    invoices: selectBillingInvoices(state),
  }),
  mapActionsToDispatchToProps({
    fetchInvoices: GetCustomerInvoices,
  }),
)(LastMonthInvoice);

export default LastMonthInvoiceHoc;
